export const info = {
    email: 'hla306',
    domain: 'sfu.ca',
    mobile_three: '(236)',
    mobile_mid_three: '989',
    mobile_last_four: '6023'
}